<template>
  <!--dialog表单 -->
  <el-dialog
    v-el-drag-dialog
    ref="dialog__wrapper"
    :title="reportTitle"
    custom-class="ReportDialog"
    :visible.sync="visible"
    :close-on-click-modal="
      targetStatus === 11 || targetStatus === 20 || targetStatus === 50
    "
    :close-on-press-escape="
      targetStatus === 11 || targetStatus === 20 || targetStatus === 50
    "
    :width="dialogWidth"
    append-to-body
    @open="initReport"
    @close="reportDialogClose"
  >
    <div class="dialog-body">
      <!-- dialog表单 -->
      <report-dialog
        :title="reportInsideTitle"
        :connectProps="connectInsideProps"
        :dataRow="dataRowInside"
        :model="modelInside"
        :reportDialogVisible="reportInsideDialogVisible"
        @changeSize="changeSize"
        @reportDialogClose="reportInsideDialogVisible = false"
        @handleConnect="handleInsideConnect"
        @handleLink="handleInsideLink"
      />
      <transition name="fade">
        <dialog-report-editor
          ref="report"
          v-if="visible"
          :connectProps="connectProps"
          :useRouter="false"
          :dialogModel="true"
          @changeTitle="changeTitle"
          @changeSize="changeSize"
          @handleConnect="handleConnect"
          @handleLink="handleLink"
          @AbortForm="$emit('reportDialogClose')"
        />
      </transition>
    </div>
    <div
      class="line"
      v-elDragWidth="$refs.dialog__wrapper"
      @changeDone="handleChangeSize"
    ></div>
  </el-dialog>
</template>
<script>
import DialogReportEditor from '@/views/Report/index.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ReportDialog',
  components: {
    DialogReportEditor
  },
  props: {
    title: '',
    connectProps: {
      type: Object,
      default() {
        return {}
      }
    },
    dialogHeight: {
      type: String,
      default: '500px'
    },
    dialogWidth: {
      type: String,
      default: '50%'
    },
    dataRow: Object,
    model: Number,
    reportDialogVisible: Boolean
  },
  computed: {
    visible: {
      get: function () {
        return this.reportDialogVisible
      },
      set: function (newVal) {
        this.reportInsideDialogVisible = newVal
      }
    },
    ...mapGetters(['formFilter'])
  },
  data() {
    return {
      targetStatus: 11,
      reportTitle: '',
      reportInsideTitle: '',
      connectInsideProps: {},
      dataRowInside: {},
      modelInside: 0,
      reportInsideDialogVisible: false
    }
  },
  methods: {
    handleInsideLink(dataRow, model, reportTitle) {
      this.dataRowInside = dataRow
      this.modelInside = model
      this.reportInsideTitle = reportTitle
      this.reportInsideDialogVisible = true
    },
    handleInsideConnect(dataRow, model, connectData, reportTitle) {
      console.log(dataRow, model, connectData, reportTitle)
      this.dataRowInside = dataRow
      this.modelInside = model
      this.connectInsideProps = connectData
      this.reportInsideTitle = reportTitle
      this.reportInsideDialogVisible = true
    },
    handleLink(dataRow, model, reportTitle) {
      this.handleInsideLink(dataRow, model, reportTitle)
      this.$emit('handleLink', dataRow, model, reportTitle)
    },
    handleConnect(dataRow, model, connectData, reportTitle) {
      console.log('reportDialog')
      this.handleInsideConnect(dataRow, model, connectData, reportTitle)
      this.$emit('handleConnect', dataRow, model, connectData, reportTitle)
    },
    changeTitle(targetStatus) {
      this.targetStatus = targetStatus
      this.escClose()
      switch (targetStatus) {
        case 10:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.create')}`
          break
        case 50:
        case 51:
        case 11:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.check')}`
          break
        case 12:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.edit')}`
          break
        case 20:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.check')}`
          break
        case 30:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.start')}`
          break
        case 40:
          this.reportTitle = `${this.title.split('-')[0]}-${this.$t('buttons.handle')}`
          break
      }
    },
    escClose() {
      if (this.targetStatus === 11 || this.targetStatus === 50) {
        document.onkeyup = e => {
          if (e.keyCode === 27) {
            this.visible = false
          }
        }
      } else {
        document.onkeyup = null
      }
    },
    initReport() {
      this.reportInsideDialogVisible = false
      this.$nextTick(async () => {
        this.escClose()
        this.reportTitle = this.title
        this.$refs.report.currentFormFilter = JSON.parse(JSON.stringify(this.formFilter))
        // 判断自己是不是第一条或最后一条
        if (this.$refs.report.currentFormFilter) {
          if (this.$refs.report.currentFormFilter.tableDataQueryTotal === this.$refs.report.currentFormFilter.currentIndex) {
            this.$refs.report.lastRecord = true
          }
          if (this.$refs.report.currentFormFilter.pageIndex === 1 && this.$refs.report.currentFormFilter.currentIndex === 1) {
            this.$refs.report.firstRecord = true
          }
          this.$store.dispatch('setFormFilter', null)
        }
        await this.$refs.report.getTemplateAttribute(this.dataRow.templateId)
        this.$nextTick(() => {
          // this.$refs.report.isWorkFlow = this.dataRow.inWorkflow
          this.$refs.report.$refs.reportEditor.dialogModel = true
          this.$refs.report.$refs.reportEditor.InitializeReport(this.dataRow, this.model)
          // this.$refs.report.getTemplateAttribute()
          if (this.model) {
            this.$refs.report.getTemplateState(this.dataRow.templateId, this.dataRow.rid || this.dataRow.recordId)
          }
        })
      })
    },
    reportDialogClose() {
      if (this.$refs.report.$refs.reportEditor.statisticsWorker) {
        this.$refs.report.$refs.reportEditor.statisticsWorker.terminate()
      }
      if (this.$refs.report.$refs.reportEditor.DropToken()) {
        this.$emit('reportDialogClose')
      }
    },
    handleChangeSize(data) {
      this.$refs.report.$refs.reportEditor.spreadSheet.resize()
    },
    changeSize(height, width) {
      var handleObj = this.$refs.dialog__wrapper.$el.querySelector('.el-dialog')
      console.log(height, width)
      height = ((document.body.clientHeight - 50) < height ? document.body.clientHeight - 50 : height)
      width = (document.body.clientWidth < width ? document.body.clientWidth : width)
      handleObj.style.width = (width < 275 ? 275 : width) + 'px'
      handleObj.style.height = (height < 330 ? 330 : height) + 'px'
      this.$refs.report.$refs.reportEditor.spreadSheet.resize()
    }
  }
}
</script>
<style lang="scss" scope>
.ReportDialog {
  min-width: 300px;
  height: 60vh;
  min-height: 300px;
  .layoutForm {
    height: 100%;
    .el-scrollbar {
      height: calc(100% + 17px) !important;
    }
    .vue-grid-layout {
      height: 100% !important;
    }
  }
  .splitter-pane {
    & > div {
      height: 100%;
      & > div {
        height: 100%;
      }
    }
  }
  .app-container {
    padding: 0;
  }

  .form-flip {
    top: 10px !important;
    right: 10px !important;
  }

  .el-dialog__body {
    height: 100%;
  }
  .dialog-body {
    position: relative;
    overflow: hidden;
    height: calc(100% - 50px);
  }
  .line {
    position: absolute;
    right: 0px;
    bottom: 0px;
    cursor: se-resize;
    width: 0px;
    height: 0px;
    border-color: #e8eaec transparent;
    border-width: 0 0 15px 15px;
    border-style: solid;
    z-index: 999;
  }
}
</style>
